import { useEffect, useState } from 'react';
import './index.scss';
import StateSucc from './page/stateSucc';
import StateFail from './page/stateFail';
import StateRefuse from './page/stateRefuse';
// import CreditCardFail from './page/creditCardFail';
// import CreditCardSucc from './page/creditCardSucc';
import { qualificationResult, getState } from '@src/service/ownService';
import { Toast, ErrorBlock, DotLoading } from 'antd-mobile';
import StatePending from './page/statePending';

export default function Index() {
  const [userInfo, setUser] = useState<any>('');

  const [nodeNel, setNodeNel] = useState<any>(
    <ErrorBlock
      style={{ '--image-height-full-page': '100px' }}
      fullPage
      description={<DotLoading color="primary" />}
      title=""
      status="busy"
    />
  );
  useEffect(() => {
    document.title = '资格预审';
    getData();
  }, []);
  useEffect(() => {
    userInfo && init();
  }, [userInfo]);
  const init = async () => {
    try {
      const qrs = await qualificationResult();
      setNodeNel(setNode(qrs));
    } catch (error: any) {
      Toast.show(error?.errmsg || '');
    }
  };
  // 获取用户状态
  const getData = async () => {
    try {
      const data = await getState();
      setUser(data);
    } catch (err: any) {
      Toast.show(err?.errmsg);
    }
  };
  const setNode = (data: any) => {
    if (data?.status == '1') {
      // document.title = "资格预审已通过";
      if (
        userInfo?.status == 5 &&
        userInfo?.statusType == 'LOAN_STATUS'
      ) {
        // return <CreditCardSucc />
        return <StateRefuse assessTime={data.assessTime} type="fq" />;
      } else {
        return <StateSucc />;
      }
    }
    if (data?.status == '3') {
      // document.title = "资格预审已驳回";
      return <StateFail refuse_type={data.refuse_type} />;
    }
    if (data?.status == '9') {
      // document.title = "资格预审已拒绝";
      return <StateRefuse assessTime={data.assessTime} />;
    }

    // // 资格评估失败
    // if (data?.status == '2' && data?.isCreditCard && data?.creditLimitType) {
    //   return <CreditCardFail />;
    // }
    // document.title = "资格预审-待评估";
    return <StatePending />;
  };
  return nodeNel;
}
